var I;!function(I){I.PRIVATE_FILE="PRIVATE_FILE",I.PUBLIC_FILE="PUBLIC_FILE"}(I||(I={}));export{I as FileTypeEnum};